import React, { Component } from 'react';
import '../App.css';
import ArticleService from '../services/article-service';
import moment from 'moment';

export default class ArticlePost extends Component {

  state = {
    html: '',
    lastModified: '',
    createdTime: '',
    author: '',
    title: '',
    description: '',
    relativeUrl: ''
  }

  componentDidMount() {
    this.loadArticle();
  }

  // load metadata here for article
  loadArticle = () => {
    let hash = window.location.hash;
    console.log('About to load article for ' + hash);

    // load article & metadata
    const articleService = new ArticleService();
    const htmlUrl = hash.substring(1);
    const metadataUrl = hash.substring(1).replace('.html', '.json');

    Promise.all([articleService.request(htmlUrl), articleService.request(metadataUrl)])
      .then(([htmlDataResp, metaDataResp]) => {

        const newHtml = htmlDataResp.data;
        const metadata = metaDataResp.data;

        console.log('Got html', JSON.stringify(newHtml));
        console.log('Got metadata', JSON.stringify(metadata));

        // calculate human friendly times
        let time1 = moment(metadata.lastModifiedTime, 'YYYY-MM-DDTHH:mm:ssZ');
        console.log('Parsed time1 ', time1);
        const lastModifiedTimeHuman = time1.fromNow();
        console.log('Made lastModifiedTimeHuman ', lastModifiedTimeHuman);

        let time2 = moment(metadata.createdTime, 'YYYY-MM-DDTHH:mm:ssZ');
        console.log('Parsed time2 ', time2);
        const createdTimeHuman = time2.format('HH:mm a DD-MM-YYYY')
        console.log('Made createdTimeHuman ', createdTimeHuman);

        this.setState({
          html: newHtml,
          author: metadata.frontMatter.author,
          description: metadata.frontMatter.description,
          image: metadata.frontMatter.image,
          title: metadata.frontMatter.title,
          createdTimeHuman: createdTimeHuman,
          lastModifiedTime: metadata.lastModifiedTime,
          lastModifiedTimeHuman: lastModifiedTimeHuman,
          relativeUrl: metadata.relativeUrl
        });
      });
  }

  makeRelativeImageUrl = () => {
    let regex = /[^/]+\.*\.html$/gi;
    let rootPath = this.state.relativeUrl.replace(regex, '');
    let relativeImageUrl = `posts/${rootPath + this.state.image}`;
    return relativeImageUrl;
  }

  makeRelativeNavUrl = () => {
    return '#' + this.state.relativeUrl;
  }

  render() {
    return (

      <article className="card mb-4">
        <header className="card-header text-center">
          <div className="card-meta">
            <span>
              last edited <time className="timeago">{this.state.lastModifiedTimeHuman} </time> by {this.state.author}
            </span>
          </div>
          <a href={this.makeRelativeNavUrl()}>
            <h1 className="card-title">
              {this.state.title}
            </h1>
          </a>
        </header>
        <a href={this.makeRelativeNavUrl()}>
          <img className="card-img" src={this.makeRelativeImageUrl()} alt="" />
        </a>
        <div className="card-body">
          <p dangerouslySetInnerHTML={{ __html: this.state.html }}>
          </p>
        </div>
        <hr />
        <div class="card-meta text-center">
          <span>
            article created {this.state.createdTimeHuman}
          </span>
        </div>
      </article>

    );
  }

}